module.exports = __webpack_public_path__ + "img/privacy-black-icon.421ef801.svg";